import { render, staticRenderFns } from "./message_detail.vue?vue&type=template&id=59857fe2&scoped=true"
import script from "./message_detail.vue?vue&type=script&lang=js"
export * from "./message_detail.vue?vue&type=script&lang=js"
import style0 from "./message_detail.vue?vue&type=style&index=0&id=59857fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59857fe2",
  null
  
)

export default component.exports